// Single source of truth for toast presentation.
//
// Before this, positions were split across pages (DashboardUser used
// TOP_RIGHT, MeetingRooms / EduspaceDashboard / Login used BOTTOM_CENTER) and
// autoClose ranged from 2000 to 3000, so the same app spoke in three different
// places. Everything now routes through toastOpts().
//
// The `toastId` argument is the important part: react-toastify treats an id as
// unique, so if an effect re-runs — or a user retries a failing action — the
// existing toast is reused instead of a second copy stacking up. Give every
// distinct action its own stable id.
export const TOAST_POSITION = "top-right";
export const TOAST_AUTOCLOSE = 3000;

export const toastOpts = (toastId, overrides = {}) => ({
  toastId,
  position: TOAST_POSITION,
  autoClose: TOAST_AUTOCLOSE,
  ...overrides,
});
